import { lazy, Suspense, memo } from 'react';

// Lazy-load Mapbox component to avoid loading mapbox-gl until needed
const MapboxComponent = lazy(() => import('./Mapbox'));

// Fallback while mapbox is loading
const MapboxLoadingFallback = memo(() => {
  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      backgroundColor: '#e8e8e8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      color: '#666'
    }}>
      Loading map...
    </div>
  );
});

MapboxLoadingFallback.displayName = 'MapboxLoadingFallback';

// Export lazy-loaded component
export const LazyMapbox = memo(({ ...props }) => {
  return (
    <Suspense fallback={<MapboxLoadingFallback />}>
      <MapboxComponent {...props} />
    </Suspense>
  );
});

LazyMapbox.displayName = 'LazyMapbox';
